import { head, pipe, replace, split } from 'ramda';

import { type Region } from '@/types';

export const LANGUAGES = ['de', 'en', 'es', 'fr', 'nl', 'pt'] as const;
export type Language = (typeof LANGUAGES)[number];
export const isLanguage = (str: string) => LANGUAGES.includes(str as Language);

export const regionToLanguages: Record<Region, Language[]> = {
  de: ['de', 'en'],
  es: ['es', 'en'],
  fr: ['fr', 'en'],
  nl: ['nl', 'en'],
  pt: ['pt', 'en'],
  uk: ['en'],
  us: ['en'],
  ww: ['en'],
};

export const regionMainLanguage: Record<Region, Language> = {
  de: 'de',
  es: 'es',
  fr: 'fr',
  nl: 'nl',
  pt: 'pt',
  uk: 'en',
  us: 'en',
  ww: 'en',
};

export const getLanguageName = (language: Language, targetLanguage: Language) =>
  new Intl.DisplayNames(targetLanguage, {
    fallback: 'code',
    type: 'language',
  }).of(language) as string;

type GenericLocale = `${Language}-${string}` | `${Language}_${string}`;
export const getLanguageFromLocale = pipe(
  replace('-', '_'),
  split('_'),
  head
) as (locale: GenericLocale) => Language;
